const __version__ ='boq-mebank_v1.0'

module.exports = {
    __version__
}

